var map = {
	"./ad.svg": 1706,
	"./at.svg": 7905,
	"./au.svg": 5534,
	"./be.svg": 5804,
	"./br.svg": 2925,
	"./ca.svg": 2333,
	"./cy.svg": 6681,
	"./de.svg": 8975,
	"./ee.svg": 7132,
	"./es.svg": 5194,
	"./fi.svg": 6190,
	"./fr.svg": 8850,
	"./gb.svg": 7216,
	"./gr.svg": 3450,
	"./hr.svg": 7950,
	"./ie.svg": 4588,
	"./in.svg": 5562,
	"./it.svg": 4638,
	"./lt.svg": 9924,
	"./lu.svg": 1108,
	"./lv.svg": 1353,
	"./mc.svg": 2526,
	"./mt.svg": 6569,
	"./mx.svg": 5560,
	"./nl.svg": 1440,
	"./pt.svg": 5319,
	"./si.svg": 4329,
	"./sk.svg": 3509,
	"./sm.svg": 2792,
	"./us.svg": 5583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2845;